var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notFound"},[_vm._m(0),_c('div',{staticClass:"link"},[_c('el-button',{attrs:{"type":"primary"},on:{"click":_vm.goBack}},[_vm._v("返回登录")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"img"},[_c('img',{attrs:{"src":require("../../assets/404.jpg")}})])
}]

export { render, staticRenderFns }